import { render, staticRenderFns } from "./viprule.vue?vue&type=template&id=14878a92&scoped=true&"
import script from "./viprule.vue?vue&type=script&lang=js&"
export * from "./viprule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14878a92",
  null
  
)

export default component.exports